import { FETCH_ALL } from "../stores/action-types";

export default {
    // module assets
    state: {
        item: {},
        items: []
     },
    getters: {
        
    },
    actions: {
        [FETCH_ALL] ({commit}, products) {

           commit(FETCH_ALL, products);
        }
    },
    mutations: {
        [FETCH_ALL] (state) {

            state.items = state;
        }
    },
}
